import { AppBar } from '@carto/meridian-ds/components'
import { ReactNode } from 'react'

interface CartoAppBarProps {
  showDrawerButton
  handleDrawerVisibility?
  brandLogo
  brandText?: string | ReactNode
  secondaryText?: string | ReactNode
  children?
}

function CartoAppBar({
  showDrawerButton,
  handleDrawerVisibility,
  brandLogo,
  brandText = '',
  secondaryText = '',
  children,
  ...rest
}: CartoAppBarProps) {
  return (
    <AppBar
      {...rest}
      component="header"
      position="relative"
      showBurgerMenu={showDrawerButton}
      onClickMenu={handleDrawerVisibility}
      brandLogo={brandLogo}
      brandText={brandText}
      secondaryText={secondaryText}
      sx={{
        // using sx here beacuse `styled` causes a conflict with the types from @carto/meridian-ds
        zIndex: 995
      }}
    >
      {children}
    </AppBar>
  )
}

export default CartoAppBar
